<template>
  <h1 v-if="type === 'h1'" :class="className">
    <slot></slot>
  </h1>
  <h2 v-else-if="type === 'h2'" :class="className">
    <slot></slot>
  </h2>
  <h3 v-else-if="type === 'h3'" :class="className">
    <slot></slot>
  </h3>
  <h4 v-else-if="type === 'h4'" :class="className">
    <slot></slot>
  </h4>
  <h5 v-else-if="type === 'h5'" :class="className">
    <slot></slot>
  </h5>
  <h6 v-else-if="type === 'h6'" :class="className">
    <slot></slot>
  </h6>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "l",
    },
    type: {
      type: String,
      default: "h2",
    },
    center: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    className() {
      return {
      [this.size]: this.size,
      center: !!this.center
    }}
  }
}
</script>

<style lang="scss">
.center { text-align: center; }
h1 {
  &.xl {}
  &.l {
    font-size: 48px;
    font-weight: 500;
    margin: 10px 0 30px;
    @media (max-width: 767px) {
      font-size: 30px;
      margin: 10px 0;
    }
  }
  &.ml {}
  &.s {}
  &.xs {}
}
h2 {
  &.xl {}
  &.l {
    font-size: 36px;
    font-weight: 500;
    margin: 5px 0 20px;
    letter-spacing: -1px;
    @media (max-width: 767px) {
      font-size: 26px;
      margin: 0px 0 10px
    }
  }
  &.m {
    font-size: 33px;
  }
  &.s {}
  &.xs {}
}
h3 {
  &.xl {
    font-size: 48px;
    font-weight: 500;
    margin: 25px 0 0;
    @media (max-width: 767px) {
      font-size: 30px;
      margin: 15px 0 0;
    }
  }
  &.l {}
  &.m {}
  &.s {}
  &.xs {}
}
h4 {
  &.xl {}
  &.l {}
  &.m {}
  &.s {
    font-weight: 400;
    font-size: 18px;
    margin: 5px 0 15px;

    @media (max-width: 767px) {
      font-size: 13px;
      margin: 0px 0 8px
    }
  }
  &.xs {}
}
h5 {
  font-weight: 400;
  margin: 5px 0 15px;
  &.xl {}
  &.l { font-size: 21px; }
  &.m { font-size: 19px; }
  &.s { font-size: 18px;margin: 0; }
  &.xs {}
}
h6 {
  font-weight: 300;
  &.xl {}
  &.l { font-size: 19px; }
  &.m {}
  &.s {}
  &.xs {}
}
</style>



// WEBPACK FOOTER //
// Heading.vue?5eee23b7